<template>
  <div v-loading.body="loading">
    <header-tabs :active="$route.path"></header-tabs>
    <el-row class="filter">
      <div
        style="
          width: 80%;
          margin: 0 auto;
          margin-top: 20px;
          margin-bottom: 20px;
        "
      >
        <el-form
          ref="form"
          :model="form"
          label-width="180px"
          class="demo-ruleForm"
        >
          <el-form-item label="是否开启质检波次：">
            <el-switch
              v-model="form.open_quality_wave"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </el-form-item>
          <p>质检拣货任务</p>
          <el-form-item label="任务最大数量：">
            <el-input
              v-model="form.max_quality_task_goods_num"
              placeholder="请输入最大拣货任务商品数量"
              type="number"
              style="width: 50%"
            ></el-input>
          </el-form-item>

          <p>质检汇总设置</p>
          <el-form-item label="有备注汇总波次上限:">
            <el-input
              v-model="form.max_quality_yes_remark_wave_summary_num"
              placeholder="请输入最大波次数量"
              type="number"
              style="width: 50%"
            ></el-input>
          </el-form-item>
          <el-form-item label="无备注汇总波次上限：">
            <el-input
              v-model="form.max_quality_no_remark_wave_summary_num"
              placeholder="请输入最大波次数量"
              type="number"
              style="width: 50%"
            ></el-input>
          </el-form-item>
          <p>改标拣货任务</p>
          <el-form-item label="任务最大数量：">
            <el-input
              v-model="form.max_label_task_goods_num"
              placeholder="请输入最大拣货任务商品数量"
              type="number"
              style="width: 50%"
            ></el-input>
          </el-form-item>
          <el-form-item label="波次数量上限：">
            <el-input
              v-model="form.max_label_task_wave_limit_num"
              placeholder="请输入最大波次数量"
              type="number"
              style="width: 50%"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否单汇总生成拣货任务：">
            <el-switch
              v-model="form.is_only_summary_picking"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </el-form-item>

          <p>改标汇总设置</p>
          <el-form-item label="汇总人数上限：">
            <el-input
              v-model="form.max_label_group_num"
              placeholder="请输入最大汇总用户数量"
              type="number"
              style="width: 50%"
            ></el-input>
          </el-form-item>
          <p>PC质检提示</p>
          <el-form-item label="PC质检提示：">
            <el-input
              v-model="form.quality_text"
              placeholder="200字以内"
              type="textarea"
              style="width: 50%"
            ></el-input>
          </el-form-item>
          <el-form-item label="提示时间: ">
            <el-input
              v-model.number="form.quality_text_time"
              style="width: 120px"
              type="number"
              min="0"
            ></el-input>
            秒
          </el-form-item>
          <el-form-item prop="is_height_goods_safety_clasp" label-width="78px">
            当商品采购价>=
            <YsInput
              v-model.number="form.high_value_price"
              style="width: 100px"
              pattern="digit"
              min="0"
            >
            </YsInput>
            ，记录为高单价商品并提醒商品绑定安全扣

            <el-switch
              v-model="form.is_height_goods_safety_clasp"
              :active-value="1"
              :inactive-value="2"
            ></el-switch>
            <el-button
              style="margin: 0px 10px"
              type="success"
              size="small"
              @click="handleExportHighPrice"
            >
              导出高单价商品数据
            </el-button>
            <el-upload
              style="display: inline-block"
              :action="actionUrl"
              name="excel"
              :on-success="highPriceImportSuccess"
              :on-error="highPriceImportError"
              :show-file-list="false"
              with-credentials
            >
              <el-button size="small" type="primary">
                导入高单价商品数据
              </el-button>
            </el-upload>
          </el-form-item>
          <el-form-item prop="is_height_goods_safety_clasp" label-width="78px">
            当商品售价>=
            <YsInput
              v-model.number="form.qa_tips_price"
              style="width: 100px"
              pattern="digit"
              min="0"
            >
            </YsInput>
            ，【售后点货】、【PC质检】、【PC修复】提示语句
            <YsInput
              v-model="form.qa_tips_text"
              maxlength="15"
              show-word-limit
              style="width: 300px"
            >
            </YsInput>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
    <el-row> </el-row>
  </div>
</template>

<script>
import HeaderTabs from "../wavepicking/components/HeaderTabs.vue";
import apiBaseURL from "@/utils/baseUrl.js";
import { getExportHighGoodsNo } from "@/openapi/erp/AdminSetting.js";

export default {
  components: { HeaderTabs },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      form: {
        origin: 1,
      },
      loading: false,
      tableLoading: false,
      url: "/erp/AdminSetting/qualityLabelSetting",
      filterFold: false,
      supplyData: null,
      actionUrl: `${apiBaseURL}/erp/AdminSetting/importHighGoodsNo`,
    };
  },
  computed: {
    filteredForm() {
      // eslint-disable-next-line no-restricted-syntax
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.get(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          // if(JSON.stringify(res.data.data) != "{}"){
          console.log(res.data.data.value);
          this.form = res.data.data.value;
          // }
        }
      });
    },
    onSubmit() {
      console.log(this.form);
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.success(res.data.msg);
        }
      });
    },
    // 导出高单价商品数据
    handleExportHighPrice() {
      // 兼容safari的做法 先打开空页面再去加载资源
      const winRef = window.open("", "_blank");
      getExportHighGoodsNo().then((res) => {
        winRef.location = apiBaseURL + res.file;
      });
    },
    // 高单价商品数据导入成功
    highPriceImportSuccess(res) {
      const { code, msg } = res;
      if (code === 200) {
        this.$message.success(msg);
      } else {
        this.$message({
          message: msg,
          type: "error",
        });
      }
    },
    // 高单价商品数据导入失败
    highPriceImportError() {
      this.$message.error("导入发生错误, 请及时联系技术");
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/adminsetting/QualityLabelSetting.vue